module.exports = __webpack_public_path__ + "static/img/day1.5e37cfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour2/day1.jpg
// module id = KxDI
// module chunks = 0